/*
 *
 * ControlAccessModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import ControlAccessModal from './ControlAccessModalContainer'

export default ControlAccessModal
